import { render } from "./TemplateVariables.vue?vue&type=template&id=d6c3a87e"
import script from "./TemplateVariables.vue?vue&type=script&lang=js"
export * from "./TemplateVariables.vue?vue&type=script&lang=js"

import "./TemplateVariables.vue?vue&type=style&index=0&id=d6c3a87e&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__